// src/lib/calcScores.js

import { TRAITS, SCALE_MIN, SCALE_MAX } from "../data/questions";

/**
 * answers: { [questionId]: number }  // 예: { Q1: 4, Q2: 2, ... }
 * questions: data/questions.js의 questions 배열
 *
 * return: { E: 0~100, I: 0~100, ... }
 */
export function calcScores(questions, answers) {
  // 1. 초기화
  const rawScores = {};
  const maxScores = {};
  const finalScores = {};

  TRAITS.forEach((t) => {
    rawScores[t] = 0;
    maxScores[t] = 0;
    finalScores[t] = 0;
  });

  // 2. 각 질문에 대해 점수 누적
  questions.forEach((q) => {
    const answer = answers[q.id];

    // 답변 안 한 문항은 스킵
    if (answer == null) return;

    // 스케일 범위 안으로 클램프(혹시 이상값 들어올 경우 대비)
    const clamped = Math.min(SCALE_MAX, Math.max(SCALE_MIN, Number(answer)));

    // 1~5 → 0~1 정규화
    let value = (clamped - SCALE_MIN) / (SCALE_MAX - SCALE_MIN);

    // reverse면 뒤집기 (높게 답할수록 낮은 값으로 반영)
    if (q.reverse) {
      value = 1 - value;
    }

    // 이 질문이 영향을 주는 trait들에 가중치 반영
    Object.entries(q.weights || {}).forEach(([trait, weight]) => {
      const w = Number(weight) || 0;
      if (!TRAITS.includes(trait) || w === 0) return;

      rawScores[trait] += value * w;
      maxScores[trait] += 1 * w; // 이 문항을 만점(1.0)으로 받았을 때
    });
  });

  // 3. 0~100 스케일로 변환
  TRAITS.forEach((trait) => {
    const max = maxScores[trait];

    if (max <= 0) {
      finalScores[trait] = 0;
    } else {
      const ratio = rawScores[trait] / max; // 0~1
      finalScores[trait] = Math.round(ratio * 100); // 0~100
    }
  });

  return finalScores;
}
